import { Slide } from "react-reveal";
import whatsAppIcon from "../assets/images/icons/whatsapp-business-icon.svg";

const FloatingButton = () => {
  return (
    <div className="relative">
      <div className="floating-button-container">
        <Slide right>
          <button className="whatsapp-button button">
            <a
              href="https://wa.me/256702096666"
              target="_blank"
              rel="noopener noreferrer"
              title="WhatsApp NTUNA.COM"
            >
              <img src={whatsAppIcon} class="icon" alt="Whatsapp Icon" />
            </a>
          </button>
        </Slide>
      </div>
    </div>
  );
};

export default FloatingButton;
